/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PrintOptionsModalComponent } from '../modals/print-options-modal.component';

@Component({
  selector: 'xrx-print-settings',
  templateUrl: './xrx-print-settings.component.html',
  styleUrls: ['./xrx-print-settings.component.less'],
  standalone: false,
})
export class XrxPrintSettingsComponent implements OnInit, OnDestroy {
  @Input() param: any;
  @Input() name: string;
  @Input() label: string;
  @Input() selectedValue: any;
  @Input() showIcon = true;
  @Input() valuePosition = 'right';
  @Output() change = new EventEmitter<any>();
  @Output() validation = new EventEmitter<any>();
  @Output() paramChange = new EventEmitter<any>();
  @Output() selectedValueChange = new EventEmitter<any>();

  private _value: string;
  @Input() set value(updatedValue: string) {
    if (updatedValue) {
      this._value = updatedValue;
      this.selectedValue = this.param.options.find(
        (option: any) => option.value === this.value,
      );
    }
  }
  get value(): string {
    return this._value;
  }

  constructor(private modalService: NgbModal) {}

  ngOnInit() {
    this.name = this.name || this.param.name;
    this.label = this.label || this.param.label;

    if (this.value) {
      this.selectedValue = this.param.options.find(
        (option: any) => option.value === this.value,
      );
    } else {
      this.value = this.param.value;
      this.selectedValue = this.param.selectedValue ?? '';
    }
  }

  openModal(event: Event) {
    const modalRef = this.modalService.open(PrintOptionsModalComponent, {
      windowClass: 'xrx-modal',
      size: 'sm',
      centered: true,
      backdrop: 'static',
    });
    modalRef.componentInstance.param = this.param;
    modalRef.result.then(
      (selectedOption: any) => {
        this.setValue(selectedOption);
      },
      () => {},
    );
  }

  setValue(option: any) {
    this.selectedValue = option;
    this.value = option.value;
    this.change.emit(option);
  }

  ngOnDestroy() {}
}
